if (!customElements.get("m-announcement-bar")) {
  class MAnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.autoplayTimer = null;
    }

    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider) return;

      this.slides = Array.from(this.querySelectorAll("[data-announcement-slide]"));
      if (this.slides.length < 2) return;

      this.autoplay = this.dataset.enableAutoplay === "true";
      this.autoplaySpeed = Math.max(parseInt(this.dataset.autoplaySpeed, 10) || 5, 2) * 1000;
      this.nextButton = this.querySelector(".swiper-button-next");
      this.previousButton = this.querySelector(".swiper-button-prev");

      this.showSlide(0);
      this.nextButton?.addEventListener("click", this.handleNextClick);
      this.previousButton?.addEventListener("click", this.handlePreviousClick);
      this.addEventListener("mouseenter", () => this.stopAutoplay());
      this.addEventListener("mouseleave", () => this.startAutoplay());
      this.addEventListener("focusin", () => this.stopAutoplay());
      this.addEventListener("focusout", () => this.startAutoplay());
      document.addEventListener("visibilitychange", this.handleVisibilityChange);
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      this.nextButton?.removeEventListener("click", this.handleNextClick);
      this.previousButton?.removeEventListener("click", this.handlePreviousClick);
      document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    }

    handleNextClick = (event) => {
      event.preventDefault();
      this.changeSlide(1);
    };

    handlePreviousClick = (event) => {
      event.preventDefault();
      this.changeSlide(-1);
    };

    handleVisibilityChange = () => {
      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.startAutoplay();
      }
    };

    showSlide(index) {
      this.currentIndex = index;

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === index;
        slide.classList.toggle("is-active", isActive);

        if (isActive) {
          slide.removeAttribute("aria-hidden");
        } else {
          slide.setAttribute("aria-hidden", "true");
        }

        const link = slide.querySelector("a");
        if (link) link.tabIndex = isActive ? 0 : -1;
      });
    }

    changeSlide(direction) {
      this.stopAutoplay();
      this.showSlide((this.currentIndex + direction + this.slides.length) % this.slides.length);
      this.startAutoplay();
    }

    startAutoplay() {
      if (!this.autoplay || this.autoplayTimer || document.hidden) return;

      this.autoplayTimer = window.setInterval(() => {
        this.showSlide((this.currentIndex + 1) % this.slides.length);
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (!this.autoplayTimer) return;
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  customElements.define("m-announcement-bar", MAnnouncementBar);
}
